(function() {
    var bar = document.querySelector('.share-bar');
    if (!bar) return;

    var url = encodeURIComponent(bar.dataset.shareUrl);
    var title = encodeURIComponent(bar.dataset.shareTitle);

    var linkedin = bar.querySelector('.share-linkedin');
    var twitter = bar.querySelector('.share-twitter');
    var facebook = bar.querySelector('.share-facebook');
    var copyBtn = bar.querySelector('.share-copy');

    if (linkedin) linkedin.href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + url;
    if (twitter) twitter.href = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title;
    if (facebook) facebook.href = 'https://www.facebook.com/sharer/sharer.php?u=' + url;

    if (copyBtn) {
        copyBtn.addEventListener('click', function() {
            navigator.clipboard.writeText(bar.dataset.shareUrl).then(function() {
                copyBtn.classList.add('copied');
                setTimeout(function() { copyBtn.classList.remove('copied'); }, 2000);
            });
        });
    }
})();
